import { Button } from "@/components/ui/button"
import { Eye, Pencil, Trash2 } from "lucide-react"
import { AcoesLinhaProps } from "../relacao-pagamentos.types"

export function AcoesLinha({ onView, onEdit, onDelete }: AcoesLinhaProps) {
  return (
    <div className="flex items-center gap-[10px] p-[10px] rounded-[30px]">
      <Button
        variant="ghost"
        size="icon"
        aria-label="Visualizar lançamento"
        className="h-6 w-6 p-0 text-gray-400 hover:text-green-400 hover:bg-green-500/10"
        onClick={onView}
      >
        <Eye className="w-6 h-6 text-green-400" />
      </Button>

      <Button
        variant="ghost"
        size="icon"
        aria-label="Editar lançamento"
        className="h-6 w-6 p-0 text-gray-400 hover:text-blue-400 hover:bg-blue-500/10"
        onClick={onEdit}
      >
        <Pencil className="w-6 h-6" />
      </Button>

      <Button
        variant="ghost"
        size="icon"
        aria-label="Excluir lançamento"
        className="h-6 w-6 p-0 text-gray-400 hover:text-red-400 hover:bg-red-500/10"
        onClick={onDelete}
      >
        <Trash2 className="w-6 h-6 text-red-400" />
      </Button>
    </div>
  )
}
